import type { ReactNode } from "react";
import DivixLogo from "../../assets/img/divixNegro.png";
import { GetEmployeeResponseDto } from "../../services/dtos/response/UserResponseDto";
import { Loading } from "../../components/Loading";

interface ConfirmationPageBaseProps {
  employee: GetEmployeeResponseDto | null;
  isLoading: boolean;
  error: { [key: string]: string };
  title: string;
  message: string;
  children?: ReactNode;
}

export function ConfirmationPageBase({
  employee,
  isLoading,
  error,
  title,
  message,
  children,
}: ConfirmationPageBaseProps) {
  return (
    <div className="flex flex-col min-h-screen">
      {isLoading || !employee ? <Loading /> : (
        <>
          <div 
            className="h-56 flex items-center justify-center pt-20"
            style={{
              backgroundColor: employee.headerLandingColor ?? "#e0e0e0",
            }}
          >
            <img 
              className="mx-auto"
              style={{
                maxWidth: '180px',
                maxHeight: '90px',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain'
              }}
              src={employee.imageLogoUrl ?? DivixLogo} 
              alt="Logo" 
            />
          </div>
          {error.load ? (
            <div className="text-center mt-12 mx-auto max-w-md">
              <h3 className="w-[318px] text-wrap mx-auto text-center font-light text-md sm:text-xl">
                {error.load}
              </h3>
            </div>
          ) : (
            <div className="text-center mt-12 mx-auto max-w-md">
              <h1 
                className="text-5xl mb-4"
                style={{
                  color: "#3a3a3a",
                }}
              >
                {title}
              </h1>
              <div className="max-w-60 mx-auto pt-2 pb-10">
                <span 
                  className="text-xl text-center"
                  style={{
                    color: "#3a3a3a",
                  }}
                >
                  {message}
                </span>
              </div>
              {children}
              <a
                className="text-white inline-flex mb-4 bg-primary rounded-full py-1 px-3"
                href="https://www.divix.net"
              >
                www.divix.net
              </a>
            </div>
          )}
        </>
      )}
    </div>
  );
}

